/**
 * @generated SignedSource<<855b76c9ab562215b63c3760ba34ef5f>>
 * @relayHash e6cfff3d0243792430f3f390f0e67cc5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 550c6239545e723c66e1868034184978f6d813ad2fed0618d637fdbe4244fceb

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

import isConditionsFGEnabled_provider from '@atlassian/jira-relay-provider/src/jira-journey-builder-parent-trigger-conditions.relayprovider';
import isTemplateAnalyticsEnabled_provider from '@atlassian/jira-relay-provider/src/journey-builder-template-analytics-fe.relayprovider';
import isJbRovoIntegrationEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-journey-builder-rovo-integration.relayprovider';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "550c6239545e723c66e1868034184978f6d813ad2fed0618d637fdbe4244fceb",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderconditionsmartvaluerelayprovider": isConditionsFGEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderrovointegrationrelayprovider": isJbRovoIntegrationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderparenttriggerconditionsrelayprovider": isConditionsFGEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjourneybuildertemplateanalyticsferelayprovider": isTemplateAnalyticsEnabled_provider
    }
  }
};

export default node;
